import { Download, FileText, Image as ImageIcon } from "lucide-react";

const FILES = [
  {
    group: "Einzel-PDFs (empfohlen für den dm-Druck)",
    items: [
      { label: "Vorderseite — Menü", file: "menuekarte-burkel-dm-10x14-vorderseite.pdf", meta: "PDF · 106 × 146 mm (100 × 140 mm + 3 mm Beschnitt)", icon: FileText },
      { label: "Rückseite — Logo & Website", file: "menuekarte-burkel-dm-10x14-rueckseite.pdf", meta: "PDF · 106 × 146 mm", icon: FileText },
    ],
  },
  {
    group: "Bilddateien, falls das dm-Programm kein PDF annimmt",
    items: [
      { label: "Vorderseite JPG", file: "menuekarte-burkel-dm-10x14-vorderseite.jpg", meta: "JPG · 1181 × 1654 px · 300 dpi · Endformat", icon: ImageIcon },
      { label: "Rückseite JPG", file: "menuekarte-burkel-dm-10x14-rueckseite.jpg", meta: "JPG · 1181 × 1654 px · 300 dpi · Endformat", icon: ImageIcon },
      { label: "Vorderseite JPG mit Beschnitt", file: "menuekarte-burkel-dm-10x14-vorderseite-mit-beschnitt.jpg", meta: "JPG · 1252 × 1725 px · 300 dpi", icon: ImageIcon },
      { label: "Rückseite JPG mit Beschnitt", file: "menuekarte-burkel-dm-10x14-rueckseite-mit-beschnitt.jpg", meta: "JPG · 1252 × 1725 px · 300 dpi", icon: ImageIcon },
    ],
  },
  {
    group: "Beide Seiten in einer Datei",
    items: [
      { label: "Menükarte komplett", file: "menuekarte-burkel-dm-10x14.pdf", meta: "PDF · 2 Seiten", icon: FileText },
    ],
  },
];

export default function MenuekarteDownload() {
  return (
    <div data-testid="page-menuekarte-download" className="min-h-screen bg-[#FAFAF7] py-14 md:py-20">
      <div className="max-w-2xl mx-auto px-5 md:px-10">
        <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52]">Druckdateien</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-4">
          Menükarte 10 × 14 cm
        </h1>
        <p className="text-sm text-[#757067] mt-4 leading-relaxed">
          Geburtstags-Dinner Burkel · 13. März 2027. Alle Dateien sind druckfertig:
          Endformat 100 × 140 mm hoch, 3 mm Beschnitt rundum, optimiert für mattes
          Premiumpapier mit 300 g/m².
        </p>

        <div className="mt-10 border border-[#E3DECE] bg-white p-6">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#BA6D52]">Einstellungen im dm-Fotoservice</p>
          <ul className="mt-3 space-y-1.5 text-sm text-[#2C2A26]">
            <li>Produkt: Grußkarte / Karte Klassik</li>
            <li>Format: ca. 10 × 14 cm, Hochformat</li>
            <li>Papier: Premium, matt, 300 g/m²</li>
            <li>Druck: Vorder- und Rückseite</li>
          </ul>
        </div>

        {FILES.map((block) => (
          <div key={block.group} className="mt-10">
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#BA6D52] mb-3">{block.group}</p>
            <div className="space-y-2">
              {block.items.map((f) => {
                const Icon = f.icon;
                return (
                  <a
                    key={f.file}
                    href={`/${f.file}`}
                    download
                    data-testid={`download-${f.file}`}
                    className="group flex items-center justify-between gap-4 border border-[#E3DECE] bg-white hover:border-[#BA6D52] px-5 py-4 transition-colors"
                  >
                    <span className="flex items-center gap-4 min-w-0">
                      <Icon size={18} className="text-[#BA6D52] shrink-0" />
                      <span className="min-w-0">
                        <span className="block text-sm text-[#2C2A26]">{f.label}</span>
                        <span className="block text-xs text-[#757067] mt-0.5">{f.meta}</span>
                      </span>
                    </span>
                    <Download size={16} className="text-[#757067] group-hover:text-[#BA6D52] shrink-0 transition-colors" />
                  </a>
                );
              })}
            </div>
          </div>
        ))}

        <p className="text-xs text-[#757067] mt-12 leading-relaxed">
          Tipp: Lade zuerst die Einzel-PDFs bzw. die JPGs im Endformat hoch. Nur wenn das
          dm-Programm ausdrücklich Beschnittzugabe verlangt, die Dateien „mit Beschnitt" verwenden.
        </p>
      </div>
    </div>
  );
}
